import { default as AccountIcon } from './AccountIcon';
import { default as AccountsIcon } from './AccountsIcon';
import { default as AddIcon } from './AddIcon';
import { default as AdvancedLogsIcon } from './AdvancedLogsIcon';
import { default as ApiKeysIcon } from './ApiKeysIcon';
import { default as ArchiveIcon } from './ArchiveIcon';
import { default as ArrowLeftIcon } from './ArrowLeftIcon';
import { default as ArrowUpIcon } from './ArrowUpIcon';
import { default as ArrowUpRightIcon } from './ArrowUpRightIcon';
import { default as AuthenticationIcon } from './AuthenticationIcon';
import { default as BellIcon } from './BellIcon';
import { default as BellSlashIcon } from './BellSlashIcon';
import { default as BiDirectionalArrowsIcon } from './BiDirectionalArrowsIcon';
import { default as CardIcon } from './CardIcon';
import { default as CaretDownIcon } from './CaretDownIcon';
import { default as CaretLeftIcon } from './CaretLeftIcon';
import { default as CaretRightIcon } from './CaretRightIcon';
import { default as CaretUpIcon } from './CaretUpIcon';
import { default as ChangePasswordIcon } from './ChangePasswordIcon';
import { default as CheckCircleFilled } from './CheckCircleFilled';
import { default as CheckIcon } from './CheckIcon';
import { default as CheckmarkIcon } from './CheckmarkIcon';
import { default as ClearIcon } from './ClearIcon';
import { default as CloseIcon } from './CloseIcon';
import { default as CodeIcon } from './CodeIcon';
import { default as CommandKeyIcon } from './CommandKeyIcon';
import { default as CopyIcon } from './CopyIcon';
import { default as CsvIcon } from './CsvIcon';
import { default as CustomFieldIcon } from './CustomFieldIcon';
import { default as DashboardIcon } from './DashboardIcon';
import { default as DateIcon } from './DateIcon';
import { default as DisableIcon } from './DisableIcon';
import { default as DisabledIcon } from './DisabledIcon';
import { default as DismissIcon } from './DismissIcon';
import { default as DocIcon } from './DocIcon';
import { default as DoubleCheckIcon } from './DoubleCheckIcon';
import { default as DownloadIcon } from './DownloadIcon';
import { default as EditIcon } from './EditIcon';
import { default as EnableIcon } from './EnableIcon';
import { default as EnumIcon } from './EnumIcon';
import { default as ErrorCircleFilled } from './ErrorCircleFilled';
import { default as ExpandIcon } from './ExpandIcon';
import { default as EyeClosedIcon } from './EyeClosedIcon';
import { default as EyeIcon } from './EyeIcon';
import { default as FieldMappingIcon } from './FieldMappingIcon';
import { default as FilledCaretDownIcon } from './FilledCaretDownIcon';
import { default as FilledCaretRightIcon } from './FilledCaretRightIcon';
import { default as FilterIcon } from './FilterIcon';
import { default as ForbiddenIcon } from './ForbiddenIcon';
import { default as ForwardArrowIcon } from './ForwardArrowIcon';
import { default as GlobeIcon } from './GlobeIcon';
import { default as InboxIcon } from './InboxIcon';
import { default as InfoCircleFilled } from './InfoCircleFilled';
import { default as InfoFilledIcon } from './InfoFilledIcon';
import { default as InfoIcon } from './InfoIcon';
import { default as IntegrationsIcon } from './IntegrationsIcon';
import { default as KeyIcon } from './KeyIcon';
import { default as LibraryIcon } from './LibraryIcon';
import { default as LogsIcon } from './LogsIcon';
import { default as MagicWandIcon } from './MagicWandIcon';
import { default as ManageTeamIcon } from './ManageTeamIcon';
import { default as ManualWebhookIcon } from './ManualWebhookIcon';
import { default as MarkReadIcon } from './MarkReadIcon';
import { default as MarkUnreadIcon } from './MarkUnreadIcon';
import { default as MembersIcon } from './MembersIcon';
import { default as ModalIcon } from './ModalIcon';
import { default as MoreHorizontalIcon } from './MoreHorizontalIcon';
import { default as MoreVerticalIcon } from './MoreVerticalIcon';
import { default as NavbarCollapseIcon } from './NavbarCollapseIcon';
import { default as NavbarExpandIcon } from './NavbarExpandIcon';
import { default as NotFoundIcon } from './NotFoundIcon';
import { default as OrganizationIcon } from './OrganizationIcon';
import { default as PinIcon } from './PinIcon';
import { default as PlusIcon } from './PlusIcon';
import { default as PreviewIcon } from './PreviewIcon';
import { default as ProgrammaticWebhookIcon } from './ProgrammaticWebhookIcon';
import { default as PulseIcon } from './PulseIcon';
import { default as RefreshIcon } from './RefreshIcon';
import { default as RejectIcon } from './RejectIcon';
import { default as ReloadIcon } from './ReloadIcon';
import { default as ReplyIcon } from './ReplyIcon';
import { default as RequiredFieldIndicatorIcon } from './RequiredFieldIndicatorIcon';
import { default as SearchIcon } from './SearchIcon';
import { default as SecurityIcon } from './SecurityIcon';
import { default as SendIcon } from './SendIcon';
import { default as SettingsIcon } from './SettingsIcon';
import { default as SignOutIcon } from './SignOutIcon';
import { default as SliderIcon } from './SliderIcon';
import { default as SortIcon } from './SortIcon';
import { default as SourceIcon } from './SourceIcon';
import { default as SparkleIcon } from './SparkleIcon';
import { default as StarIcon } from './StarIcon';
import { default as StepCurrentIcon } from './StepCurrentIcon';
import { default as StepUpcomingIcon } from './StepUpcomingIcon';
import { default as SyntheticWebhookIcon } from './SyntheticWebhookIcon';
import { default as ThumbsDownIcon } from './ThumbsDownIcon';
import { default as ThumbsUpIcon } from './ThumbsUpIcon';
import { default as TrashIcon } from './TrashIcon';
import { default as TriangleDownIcon } from './TriangleDownIcon';
import { default as TriangleRightIcon } from './TriangleRightIcon';
import { default as UnarchiveIcon } from './UnarchiveIcon';
import { default as UploadIcon } from './UploadIcon';
import { default as WarningCircleFilled } from './WarningCircleFilled';
import { default as WarningTriangleIcon } from './WarningTriangleIcon';
import { default as WebhookEventsIcon } from './WebhookEventsIcon';
import { default as WebhookIcon } from './WebhookIcon';
import { default as WebhookSigningSecretIcon } from './WebhookSigningSecretIcon';

// Named exports so a consumer can pull one icon. The CustomIcons object below
// references every icon, so reaching an icon through it costs the whole set.
export {
    AccountIcon,
    AccountsIcon,
    AddIcon,
    AdvancedLogsIcon,
    ApiKeysIcon,
    ArchiveIcon,
    ArrowLeftIcon,
    ArrowUpIcon,
    ArrowUpRightIcon,
    AuthenticationIcon,
    BellIcon,
    BellSlashIcon,
    BiDirectionalArrowsIcon,
    CardIcon,
    CaretDownIcon,
    CaretLeftIcon,
    CaretRightIcon,
    CaretUpIcon,
    ChangePasswordIcon,
    CheckCircleFilled,
    CheckIcon,
    CheckmarkIcon,
    ClearIcon,
    CloseIcon,
    CodeIcon,
    CommandKeyIcon,
    CopyIcon,
    CsvIcon,
    CustomFieldIcon,
    DashboardIcon,
    DateIcon,
    DisableIcon,
    DisabledIcon,
    DismissIcon,
    DocIcon,
    DoubleCheckIcon,
    DownloadIcon,
    EditIcon,
    EnableIcon,
    EnumIcon,
    ErrorCircleFilled,
    ExpandIcon,
    EyeClosedIcon,
    EyeIcon,
    FieldMappingIcon,
    FilledCaretDownIcon,
    FilledCaretRightIcon,
    FilterIcon,
    ForbiddenIcon,
    ForwardArrowIcon,
    GlobeIcon,
    InboxIcon,
    InfoCircleFilled,
    InfoFilledIcon,
    InfoIcon,
    IntegrationsIcon,
    KeyIcon,
    LibraryIcon,
    LogsIcon,
    MagicWandIcon,
    ManageTeamIcon,
    ManualWebhookIcon,
    MarkReadIcon,
    MarkUnreadIcon,
    MembersIcon,
    ModalIcon,
    MoreHorizontalIcon,
    MoreVerticalIcon,
    NavbarCollapseIcon,
    NavbarExpandIcon,
    NotFoundIcon,
    OrganizationIcon,
    PinIcon,
    PlusIcon,
    PreviewIcon,
    ProgrammaticWebhookIcon,
    PulseIcon,
    RefreshIcon,
    RejectIcon,
    ReloadIcon,
    ReplyIcon,
    RequiredFieldIndicatorIcon,
    SearchIcon,
    SecurityIcon,
    SendIcon,
    SettingsIcon,
    SignOutIcon,
    SliderIcon,
    SortIcon,
    SourceIcon,
    SparkleIcon,
    StarIcon,
    StepCurrentIcon,
    StepUpcomingIcon,
    SyntheticWebhookIcon,
    ThumbsDownIcon,
    ThumbsUpIcon,
    TrashIcon,
    TriangleDownIcon,
    TriangleRightIcon,
    UnarchiveIcon,
    UploadIcon,
    WarningCircleFilled,
    WarningTriangleIcon,
    WebhookEventsIcon,
    WebhookIcon,
    WebhookSigningSecretIcon,
};

export const CustomIcons = {
    AccountIcon: AccountIcon,
    AccountsIcon: AccountsIcon,
    AddIcon: AddIcon,
    AdvancedLogsIcon: AdvancedLogsIcon,
    ApiKeysIcon: ApiKeysIcon,
    ArchiveIcon: ArchiveIcon,
    ArrowLeftIcon: ArrowLeftIcon,
    ArrowUpIcon: ArrowUpIcon,
    ArrowUpRightIcon: ArrowUpRightIcon,
    AuthenticationIcon: AuthenticationIcon,
    BellIcon: BellIcon,
    BellSlashIcon: BellSlashIcon,
    BiDirectionalArrowsIcon: BiDirectionalArrowsIcon,
    CardIcon: CardIcon,
    CaretDownIcon: CaretDownIcon,
    CaretLeftIcon: CaretLeftIcon,
    CaretRightIcon: CaretRightIcon,
    CaretUpIcon: CaretUpIcon,
    CodeIcon: CodeIcon,
    ChangePasswordIcon: ChangePasswordIcon,
    CheckCircleFilled: CheckCircleFilled,
    CheckIcon: CheckIcon,
    CheckmarkIcon: CheckmarkIcon,
    ClearIcon: ClearIcon,
    CloseIcon: CloseIcon,
    CommandKeyIcon: CommandKeyIcon,
    CopyIcon: CopyIcon,
    CsvIcon: CsvIcon,
    CustomFieldIcon: CustomFieldIcon,
    DashboardIcon: DashboardIcon,
    DateIcon: DateIcon,
    DisabledIcon: DisabledIcon,
    DisableIcon: DisableIcon,
    DismissIcon: DismissIcon,
    DocIcon: DocIcon,
    DoubleCheckIcon: DoubleCheckIcon,
    DownloadIcon: DownloadIcon,
    EditIcon: EditIcon,
    EnableIcon: EnableIcon,
    EnumIcon: EnumIcon,
    ErrorCircleFilled: ErrorCircleFilled,
    ExpandIcon: ExpandIcon,
    EyeClosedIcon: EyeClosedIcon,
    EyeIcon: EyeIcon,
    FieldMappingIcon: FieldMappingIcon,
    FilledCaretDownIcon: FilledCaretDownIcon,
    FilledCaretRightIcon: FilledCaretRightIcon,
    FilterIcon: FilterIcon,
    ForbiddenIcon: ForbiddenIcon,
    GlobeIcon: GlobeIcon,
    ForwardArrowIcon: ForwardArrowIcon,
    InboxIcon: InboxIcon,
    InfoIcon: InfoIcon,
    InfoFilledIcon: InfoFilledIcon,
    InfoCircleFilled: InfoCircleFilled,
    IntegrationsIcon: IntegrationsIcon,
    KeyIcon: KeyIcon,
    LibraryIcon: LibraryIcon,
    LogsIcon: LogsIcon,
    MagicWandIcon: MagicWandIcon,
    ManageTeamIcon: ManageTeamIcon,
    ManualWebhookIcon: ManualWebhookIcon,
    MarkReadIcon: MarkReadIcon,
    MarkUnreadIcon: MarkUnreadIcon,
    MembersIcon: MembersIcon,
    ModalIcon: ModalIcon,
    MoreHorizontalIcon: MoreHorizontalIcon,
    MoreVerticalIcon: MoreVerticalIcon,
    NavbarCollapseIcon: NavbarCollapseIcon,
    NavbarExpandIcon: NavbarExpandIcon,
    NotFoundIcon: NotFoundIcon,
    OrganizationIcon: OrganizationIcon,
    PinIcon: PinIcon,
    PlusIcon: PlusIcon,
    PreviewIcon: PreviewIcon,
    ProgrammaticWebhookIcon: ProgrammaticWebhookIcon,
    PulseIcon: PulseIcon,
    RefreshIcon: RefreshIcon,
    RejectIcon: RejectIcon,
    ReloadIcon: ReloadIcon,
    ReplyIcon: ReplyIcon,
    RequiredFieldIndicatorIcon: RequiredFieldIndicatorIcon,
    SearchIcon: SearchIcon,
    SecurityIcon: SecurityIcon,
    SendIcon: SendIcon,
    SettingsIcon: SettingsIcon,
    SignOutIcon: SignOutIcon,
    SliderIcon: SliderIcon,
    SortIcon: SortIcon,
    SourceIcon: SourceIcon,
    SparkleIcon: SparkleIcon,
    StarIcon: StarIcon,
    StepCurrentIcon: StepCurrentIcon,
    StepUpcomingIcon: StepUpcomingIcon,
    SyntheticWebhookIcon: SyntheticWebhookIcon,
    ThumbsDownIcon: ThumbsDownIcon,
    ThumbsUpIcon: ThumbsUpIcon,
    TrashIcon: TrashIcon,
    TriangleDownIcon: TriangleDownIcon,
    TriangleRightIcon: TriangleRightIcon,
    UnarchiveIcon: UnarchiveIcon,
    UploadIcon: UploadIcon,
    WarningCircleFilled: WarningCircleFilled,
    WarningTriangleIcon: WarningTriangleIcon,
    WebhookEventsIcon: WebhookEventsIcon,
    WebhookIcon: WebhookIcon,
    WebhookSigningSecretIcon: WebhookSigningSecretIcon,
};

export default CustomIcons;
